// Que du texte

import React, { useEffect, useState } from 'react';
import Paragraph from './Paragraph';

const SlideText = ({ slide, changeState, right, user, newCheckpoint }) => {
  const [paragraphs, setParagraphs] = useState([]);
  const [state, setState] = useState(0);
  const [parent, setParent] = useState(0);
  const path = "https://connivence-salon.net/api/e-learning/assets/images/";

  const changeLocalState = (value) => {
    setState(value);
    console.log("test");

      console.log("test");
      document.body.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto' // Cette ligne est facultative car 'auto' est le comportement par défaut
      });
  }

  const isVisible = (index) => {
    if(state === index){
      return true;
    }
    else{
      if(slide?.num !== parent){
        setParent(slide.num);
        setState(0);
        return true;
      }
      else{
        return false;
      }
    }
  }

  const addLazyLoadingToImages = (htmlString) => {

    if(htmlString === undefined || htmlString === null){
      return htmlString; // Retourne la chaîne d'origine si elle est vide ou nulle
      
    }

    // Crée un élément DOM temporaire pour manipuler la chaîne HTML
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
  
    // Sélectionne toutes les balises <img> dans le contenu
    const images = tempDiv.querySelectorAll('img');
  
    // Ajoute l'attribut loading="lazy" à chaque image
    images.forEach((img) => {
      img.setAttribute('loading', 'lazy');
    });
  
    // Retourne le HTML modifié sous forme de chaîne
    return tempDiv.innerHTML;
  };

  const modifiedContent = addLazyLoadingToImages(slide.text_content);

  useEffect(() => {
    
    setParagraphs(slide.paragraphs);
    console.log(slide.correction)

    if (slide?.lesson === 1 && !document.body.classList.contains("lessons-bg")) {
      document.body.classList.add("lessons-bg");
    }

    console.log(slide?.num);
  }, [slide])
  return (
    <>
      {slide?.lesson === 1 ?
        <article className={"tplt-" + slide.template + " lesson"}>

          {
            paragraphs?.map((par, index) =>
              <Paragraph key={index} par={par} pos={index + 1} maxPos={paragraphs.length} visible={isVisible(index)} changeLocalState={changeLocalState} changeState={changeState} user={user} newCheckpoint={newCheckpoint} slide={slide} />
            )
          }
        </article>
        :
        ""
      }
      {slide?.lesson === 0 && !(slide.correction === 1 && right === false) ?
        <article className={"tplt-" + slide.template} dangerouslySetInnerHTML={{ __html: modifiedContent }}>
        </article>
        :
        ""
      }
      {
        slide?.correction === 1 && right === false ?
          <article className='tplt-inline-text'>
            <div>
              <h3>Oups ! Ce n'est pas la bonne réponse...</h3>
              <p className='line-break'>... mais la réussite est l'aboutissement d'une succession d'échecs !</p>
              <strong>Pas de panique, tu vas y arriver... Il faut persévérer !</strong>
            </div>
          </article>
          :
          ""
      }
    </>
  );
};

export default SlideText;